import { render, staticRenderFns } from "./AgendaAppuntamentiStatiListPage.vue?vue&type=template&id=d833045a&scoped=true"
import script from "./AgendaAppuntamentiStatiListPage.vue?vue&type=script&lang=js"
export * from "./AgendaAppuntamentiStatiListPage.vue?vue&type=script&lang=js"
import style0 from "./AgendaAppuntamentiStatiListPage.vue?vue&type=style&index=0&id=d833045a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d833045a",
  null
  
)

export default component.exports